import api from '../../api';

export const getSearchGlobal = (text, params) => api.get(`/global_search/${text}`, params);
